export function reformatPermissions(data) {
    const reformatted = {};

    for (const [key, value] of Object.entries(data)) {
        for (const [subKey, subValue] of Object.entries(value)) {
            if (!reformatted[subKey]) {
                reformatted[subKey] = [];
            }
            const modifiedEntries = subValue.map(entry => ({
                ...entry,
                parentKey: key
            }));
            reformatted[subKey] = reformatted[subKey].concat(modifiedEntries);
        }
    }

    return reformatted;
}
export function sanitizeAndCrop(input, len = 100) {
    let hasFirstTag = false;
    const sanitizedString = input.replace(/<\/?[^>]+(>|$)/g, (match) => {
        if (hasFirstTag) {
            return '. ';
        } else {
            hasFirstTag = true;
            return '';
        }
    });
    if (sanitizedString.length > 101) {
        return sanitizedString.slice(0, len) + '...';
    }
    return sanitizedString;
}
export function removeKeys(input, keys) {
    return Object.fromEntries(
        Object.entries(input)
            .filter(([key]) => !keys.includes(key))
    );
}